<template>
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item :to="`/industrial-property/${item.id}/forms/modifyIndustrialPropertyForm`">
            <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
            {{ $t("industrial_property.forms.modifyIndustrialProperty") }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-card class="mt-4 pa-6">
      <IndustrialPropertyFields :industrial-property="item" readonly />
      <v-divider class="mt-6 mb-5" />
      <IndustrialPropertyFiles :id="item.id" final readonly />
      <div class="text-center mt-6">
        <v-btn text @click="$router.go(-1)"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
        <DeleteObjectForm url-objects="industrial_property" object_type="industrial_property" :headers="headers" :item="item" />
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DeleteObjectForm from "@/components/delete_object/DeleteObjectForm";
import IndustrialPropertyFields from "./IndustrialPropertyFields.vue";
import IndustrialPropertyFiles from "./IndustrialPropertyFiles.vue";
import { createDefaultIndustrialProperty, normalizeIndustrialProperty } from "@/utils/industrialProperty";

export default {
  name: "DetailIndustrialProperty",
  components: { DeleteObjectForm, IndustrialPropertyFields, IndustrialPropertyFiles },
  data: () => ({ item: createDefaultIndustrialProperty() }),
  computed: {
    headers() { return [{ text: this.$t("form.industrial_property.title"), value: "title" }]; }
  },
  created() {
    axios.get(`${this.$store.state.endpoint}/user/industrial_property/${this.$route.params.id}`)
      .then(response => {
        this.item = normalizeIndustrialProperty(response.data);
        this.$store.state.sectionTitle = this.item.title;
      }).catch(error => console.error(error));
  }
};
</script>
